import { IFsNodeSchema } from "@cloudike/web_files"
import { openFilesPreviewThunk } from "features/files-preview/model/slice/filesPreviewSlice"
import { FilesPreviewModalType } from "features/files-preview/model/types/filesPreviewTypes"
import { useNavigate } from "react-router-dom"
import { useAppDispatch } from "shared/config/store"
import { getMiddlePreviewLink } from "shared/utils/filesUtils"
import { styled } from "styled-components"

import { AttachmentPreviewIcon } from "./AttachmentPreviewPlaceholder"

interface MessageAttachmentsProps {
  className?: string
  attachments: IFsNodeSchema[],
  type: FilesPreviewModalType
}

export const MessageAttachments = ({ attachments, className, type }: MessageAttachmentsProps) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const handleClick = (attachment: IFsNodeSchema) => {
    dispatch(openFilesPreviewThunk({ 
      items: [attachment as any], 
      currentItemId: attachment.id, 
      totalItemsCount: 1, 
      currentBoardInfo: null, 
      navigate, 
      modalType: type
    }))
  }

  return (
    <SMessageAttachments className={className}>
      {attachments.map((attachment) => getMiddlePreviewLink(attachment) ? (
        <SAttachment key={attachment.id} 
          src={getMiddlePreviewLink(attachment)}
          onClick={() => handleClick(attachment)}
        />
      ) : (
        <SAttachmentPlaceholder key={attachment.id}
          onClick={() => handleClick(attachment)}
        >
          <SAttachmentIcon type={attachment?.file_info?.mime} />

          <SAttachmentName>
            {attachment?.name}
          </SAttachmentName>
        </SAttachmentPlaceholder>
      ))}
    </SMessageAttachments>
  )
}

const SMessageAttachments = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`

const SAttachment = styled.img`
  width: 267px;
  height: 148px;
  border-radius: 8px;
  object-fit: cover;
  background-color: #F5F5F5;
  cursor: pointer;
`

const SAttachmentPlaceholder = styled.div`
  width: 267px;
  height: 148px;
  border-radius: 8px;
  background-color: #F5F5F5;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #00000073;
`

const SAttachmentIcon = styled(AttachmentPreviewIcon)`
  color: #00000073;
`

const SAttachmentName = styled.div`
  font-size: 12px;
  color: #00000073;
  margin-top: 8px;
`